import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class CustomerContactBus extends BaseBus
{
    constructor(data: CustomerContactBus) {
        super(data);
    }

    CID(): any {
        return this.customerContactId;
    }
    initialize(data: CustomerContactBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: CustomerContactBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setId(id: any) {
        this.customerContactId = id;
    }

    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
            this.updateUserId = userId;
        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }
    customerContactId: string;
    customerContactTypeId: string;
      customerId: string;
      firstName: string;
      lastName: string;
    title: string;
    officePhone: string;
    cellPhone: string;
    emailAddress: string;
    faxNumber: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    stateProv: string;
    postalCode: string;
    quickSearchKey: string;
    insertDt: Date;
    updateDt: Date;
    updateUserId: string;
    insertUserId: string;
    get canEdit(): boolean {
        let can: boolean = true;

        ////if ((this.hasId || (this.hasData && this.data.isAdded))) {
        //if (this.rights.MaintainQuotes) {
        //    can = true;
        //}
        ////}

        return can;
    }
}
